import Client from './Clients/ScrapingToolsClient'

const createAndRunResource = '/operations/create_and_run/'
const createAndRunDomainResource = '/operations/create_and_run/domain/'

export default {
    run(id){
        return Client.post(createAndRunResource+id+'/');
    },
    runDomain(id){
        return Client.post(createAndRunDomainResource+id+'/');
    }

}